import React from "react";
import { useTabIcon } from "./hooks/useTabIcon";
import PhotoWidgetV2 from "ui/widgets/photoUploader/PhotoWidgetV2";

export const TabIcon = () => {
  const { iconUrl, handleUploadIcon } = useTabIcon();

  return (
    <div className="tw-flex tw-items-center tw-gap-4">
      <div className="tw-relative tw-w-[72px] tw-h-[72px]">
        <PhotoWidgetV2
          selected={iconUrl}
          width={72}
          height={72}
          onChange={handleUploadIcon}
          aspect={1}
          showButton={false}
          placeHolderClickable
          showRemoveButton
        />
      </div>
      <div className="tw-text-xs tw-text-[#818E9E] tw-leading-tight">
        *Recommended format:
        <br />
        100 x 100 pixels (PNG or JPG)
      </div>
    </div>
  );
};
